'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCircleFilled, iconCircleFilledTag } from '@ni/nimble-components/dist/esm/icons/circle-filled';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCircleFilled };
export { iconCircleFilledTag };
export const NimbleIconCircleFilled = wrap(IconCircleFilled);